import { useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../firebase";

const FONT = "'Plus Jakarta Sans', sans-serif";

function Isotipo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40">
      <line x1="20" y1="5" x2="20" y2="20" stroke="#D1D5DB" strokeWidth="2"/>
      <line x1="35" y1="20" x2="20" y2="20" stroke="#D1D5DB" strokeWidth="2"/>
      <line x1="20" y1="35" x2="20" y2="20" stroke="#D1D5DB" strokeWidth="2"/>
      <line x1="5" y1="20" x2="20" y2="20" stroke="#D1D5DB" strokeWidth="2"/>
      <circle cx="20" cy="5" r="3" fill="#E03131"/><circle cx="35" cy="20" r="3" fill="#E03131"/>
      <circle cx="20" cy="35" r="3" fill="#E03131"/><circle cx="5" cy="20" r="3" fill="#E03131"/>
      <circle cx="20" cy="20" r="6" fill="#E03131"/>
    </svg>
  );
}

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Email o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  }

  async function handleGoogleLogin() {
    setLoading(true);
    setError("");
    try {
      const provider = new GoogleAuthProvider();
      // Fuerza mostrar el selector de cuentas de Google en cada login,
      // en vez de reutilizar la sesión pegada del navegador. Evita que el
      // usuario entre con una cuenta no autorizada sin poder cambiarla
      // (problema frecuente en celulares con sesión de Google activa).
      provider.setCustomParameters({ prompt: "select_account" });
      await signInWithPopup(auth, provider);
    } catch (err) {
      if (err.code !== "auth/popup-closed-by-user") {
        setError("Error al iniciar sesión con Google");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={sx.container}>
      <div style={sx.card}>
        <div style={sx.logoArea}>
          <Isotipo size={40} />
          <div style={sx.logoText}>
            <span style={{ color: "#0B0F14", fontWeight: 500 }}>Obra</span>
            <span style={{ color: "#E03131", fontWeight: 700 }}>Core</span>
          </div>
        </div>
        <p style={sx.sub}>Ingresá a tu plataforma</p>

        <button onClick={handleGoogleLogin} disabled={loading} style={sx.googleBtn}>
          <svg width="18" height="18" viewBox="0 0 24 24" style={{ marginRight: 8 }}>
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continuar con Google
        </button>

        <div style={sx.divider}><span style={sx.dividerText}>o</span></div>

        <form onSubmit={handleLogin}>
          <input type="email" placeholder="Email" value={email}
            onChange={e => setEmail(e.target.value)} style={sx.input} required />
          <input type="password" placeholder="Contraseña" value={password}
            onChange={e => setPassword(e.target.value)} style={sx.input} required />
          {error && <p style={sx.error}>{error}</p>}
          <button type="submit" disabled={loading} style={sx.btn}>
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        <div style={sx.footer}>
          <span style={{ fontSize: 11, color: "#94a3b8" }}>Plataforma de gestión integral</span>
        </div>
      </div>
    </div>
  );
}

const sx = {
  container: {
    minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    background: "#f8f9fa", fontFamily: FONT,
  },
  card: {
    background: "white", borderRadius: 16, padding: "48px 40px", width: 400,
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)", borderTop: "3px solid #E03131",
  },
  logoArea: {
    display: "flex", flexDirection: "column", alignItems: "center", gap: 12, marginBottom: 8,
  },
  logoText: {
    fontSize: 28, fontFamily: FONT, letterSpacing: -0.5,
  },
  sub: {
    color: "#64748b", textAlign: "center", marginBottom: 28, fontSize: 14,
  },
  googleBtn: {
    width: "100%", display: "flex", alignItems: "center", justifyContent: "center",
    padding: "11px 16px", border: "1px solid #e2e8f0", borderRadius: 8,
    background: "white", fontSize: 14, fontWeight: 600, cursor: "pointer",
    marginBottom: 16, fontFamily: FONT, color: "#1e293b",
    transition: "background 0.15s, border-color 0.15s",
  },
  divider: {
    textAlign: "center", margin: "16px 0", position: "relative",
    borderTop: "1px solid #f1f5f9",
  },
  dividerText: {
    background: "white", padding: "0 12px", position: "relative", top: -10,
    color: "#94a3b8", fontSize: 13,
  },
  input: {
    width: "100%", padding: "11px 14px", border: "1px solid #e2e8f0",
    borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: "border-box",
    fontFamily: FONT, outline: "none", transition: "border-color 0.15s",
  },
  btn: {
    width: "100%", padding: "12px", background: "#E03131", color: "white",
    border: "none", borderRadius: 8, fontSize: 14, fontWeight: 700,
    cursor: "pointer", fontFamily: FONT, transition: "opacity 0.15s",
  },
  error: { color: "#dc2626", fontSize: 13, marginBottom: 10 },
  footer: { textAlign: "center", marginTop: 24, paddingTop: 16, borderTop: "1px solid #f1f5f9" },
};